import {useParams} from 'react-router-dom';
import {useSnackbar} from "../../../context/SnackbarContext/SnackbarContext";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {API_URL, APP_URL} from "../../../config";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import AmountControl from "../../../components/AmountControl/AmountControl";
import Chip from "@mui/material/Chip";

const useSaleDetails = () => {

    const {id} = useParams();

    const { showSnackbar } = useSnackbar();

    const [isLoading, setIsLoading] = useState(true);

    const [sale, setSale] = useState(null);

    useEffect(() => {
        const init = async () => {
            setIsLoading(true);
            await loadSale();
            setIsLoading(false);
        };

        init();
    }, []);

    const loadSale = async () => {

        try {

            const response = await axios.get(`${API_URL}/sales/${id}`);

            setSale(response.data.data);
        } catch (error) {

            showSnackbar('Statistics', 'Ocurrió un error cargando la venta', 'cancel', 'warning');
        }

    };

    const renderSaleItems = () => {
        return sale.saleItems.map((saleItem, index) => {

            const imageUrl = `${APP_URL}/storage/products/${saleItem.product.image_name}`;

            return <MDBox py={2} sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', borderBottomStyle: 'dashed', borderBottomWidth: index !== sale.saleItems.length - 1 ? 1 : 0, borderBottomColor: '#ececec'}}>
                <MDBox sx={{backgroundColor: '#f7f7f7', borderStyle: 'solid', borderWidth: 1, borderColor: '#f7f7f7', borderRadius: 2, width: 70, height: 70, position: 'relative', marginRight: 2}}>
                    <img src={imageUrl} alt={saleItem.product.name} style={{
                        position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover'}} />
                </MDBox>
                <MDBox sx={{flexGrow: 1}}>
                    <MDTypography variant="h6">{saleItem.product.name}</MDTypography>
                    <MDTypography variant="body2" sx={{fontSize: 14}}>{saleItem.product.brand}</MDTypography>
                </MDBox>
                <MDBox px={2} py={0.5}>
                    <MDTypography variant="body2" fontWeight="medium">{saleItem.quantity}</MDTypography>
                </MDBox>
            </MDBox>
        });
    };

    const renderStatusChip = (status) => {
        switch (status) {
            case 'pending':
                return <Chip size="small" color="warning" label="Pendiente"
                             variant="outlined"/>;
            case 'in_transit':
                return <Chip size="small" color="secondary" label="Preparando"
                             variant="outlined"/>;
            case 'paid':
                return <Chip size="small" color="success" label="Pagado"
                             variant="outlined"/>;
        }
    };

    return {
        id,
        isLoading,
        sale,
        renderSaleItems,
        renderStatusChip
    };
};

export default useSaleDetails;
